import { INCOME_TYPE } from '@ahmdigital/constants';
import { map } from 'lodash/fp';
import formatCurrency from '@ahmdigital/logic/lib/claim/format-currency';
import getAgrIncomeThresholds from '@ahmdigital/logic/lib/utils/get-agr-income-thresholds';

import { IncomeTierOptions } from '../add-no-rebate-income-tier';
import constants from '../../ahm-constants';

// @ts-expect-error - Automatic, Please fix when editing this file
const getIncomeTierTextWithRange = (isCompact, incomeTierData) => {
  const { incomeTier } = incomeTierData;

  if (incomeTier === constants.INCOME_TIER.TIER_0) {
    const formattedAmount = `${formatCurrency(incomeTierData?.max, {
      minimumFractionDigits: 0,
    })}`;
    return isCompact ? `<${formattedAmount}` : `${formattedAmount} or less`;
  }

  if (incomeTier === constants.INCOME_TIER.TIER_3) {
    const formattedAmount = `${formatCurrency(incomeTierData?.min, {
      minimumFractionDigits: 0,
    })}`;
    return isCompact ? `>${formattedAmount}` : `${formattedAmount} or more`;
  }

  return `${formatCurrency(incomeTierData?.min, {
    minimumFractionDigits: 0,
  })} - ${formatCurrency(incomeTierData?.max, { minimumFractionDigits: 0 })}`;
};

// @ts-expect-error - Automatic, Please fix when editing this file
const formatRate = (rate) => (rate > 1 ? `${rate}%` : `${rate}.0%`);

export type IncomeType = (typeof INCOME_TYPE)[keyof typeof INCOME_TYPE];

type Props = {
  forceDate?: string;
  incomeType: IncomeType;
  isCompact?: boolean;
};

const getIncomeTierOptions = ({
  forceDate = undefined,
  incomeType = INCOME_TYPE.COUPLE,
  isCompact = false,
}: Props): IncomeTierOptions[] => {
  const agrIncomeThresholds = getAgrIncomeThresholds(forceDate)[incomeType];
  const translatedTiers = map(
    (tier) => ({
      rate: formatRate(tier.rate),
      text: getIncomeTierTextWithRange(isCompact, tier),
      value: tier.incomeTier,
    }),
    agrIncomeThresholds,
  );
  return translatedTiers;
};

export default getIncomeTierOptions;
